import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import cls from "classnames";
import { TextField, Paper, FormGroup, Checkbox, FormControlLabel, FormLabel } from "@material-ui/core";

import { withTitle, withAuth } from "../../HoC";
import { IAdminState } from "../AdminPage/reducer";

import style from "./settings.module.scss";
import { Button } from "../../Components/button";
import { patchRequest } from "../../services/Requests";

import { fields } from "./fields";
import { translate } from "../../translations/translate";
import { priorities as availablePriorities } from "../../utils/constants";

export class Settings extends Component<any, any> {

  constructor(props) {
    super(props);
    const { device, history } = props;
    console.log("WOOO", { device, history });

    if (!device) history.push("/admin");

    this.state = {
      device: {
        ...device,
        priorities: device?.priorities || [],
      },
    };
  }

  updateState = (key, type, transform, ev) => {
    let value = ev.target.value;

    if (type === "checkbox")
      value = ev.target.checked;

    if (transform && type === "number")
      value = (Number(ev.target.value) * 60000);

    this.setState((state) => ({
      device: {
        ...state.device,
        [key]: value,
      },
    }));
  }

  updateStore = () => {
    const body = this.state.device;
    const { id } = body;
    patchRequest({
      url: `store/${id}`,
      body: {
        ...body,
        bookingActivated: body.bookingActivated ? "1" : "0",
        id: undefined,
        uuid: undefined,
      },
    }).then((res) => {
      alert("SUCCESS");
    }).catch((er) => {
      alert("ERROR");
    });
  }

  updatePriories = (key, value) => {
    if (key === 0) return;
    const { priorities } = this.state.device;
    const newPrio = [...priorities];
    newPrio[key] = value;
    this.setState((state) => {
      return {
        device: {
          ...state.device,
          priorities: newPrio,
        },
      };
    });
  }

  render() {
    const { device } = this.state;

    return (<div className={style["wrapper"]}>
      <h1> {translate("settings")} </h1>
      <Paper className={style["input-wrapper"]}>
        {fields.map(({ name, key, type, disabled, transform }, i) => {

          if (type === "checkbox") {
            return (
              <FormGroup>
                <FormLabel component="h3">Booking Options</FormLabel>
                <FormControlLabel
                  className={style["checkbox-wrapper"]}
                  control={<Checkbox
                    color="primary"
                    checked={!!device[key]}
                    onChange={(ev) => {
                    this.updateState(key, type, false, ev);
                  }} />}
                  label="Activate Booking"
                />
              </FormGroup>);
          }

          return (
            <TextField
              key={i}
              type={type}
              label={name}
              className={cls(style["input"])}
              variant="outlined"
              disabled={disabled}
              value={transform ? transform(device[key]) : (device[key] || "")}
              onChange={(ev) => this.updateState(key, type, transform, ev)}
            />);
        })}
        <FormGroup>
          <FormLabel component="h3">{translate("priority")}</FormLabel>
          {availablePriorities.map((e, i) => {
            return (<FormControlLabel
              key={e}
              control={<Checkbox
                color="primary"
                disabled={i === 0}
                checked={i === 0 ? true : device.priorities[i]}
                onChange={() => this.updatePriories(i, !device.priorities[i])}
                name={e}
              />}
              label={translate(e)}
            />);
          })}
        </FormGroup>
        <div className={style["submit-wrapper"]}>
          <Button
            onClick={this.updateStore}
            label={translate("save")}
          />
        </div>
      </Paper>
    </div>);
  }
}

const mapStateToProps = (state: { adminReducer: IAdminState }, props) => {
  const { deviceId } = props.match.params;
  return {
    device: state.adminReducer.devices.find((e) => e.uuid === deviceId),
  };
};

export default compose(
  withTitle(translate("settings")),
  withAuth(0),
  connect(mapStateToProps, null),
)(Settings);
